import { useState } from 'react';
import { StyledAside, StyledAsideList, StyledAsideLogo } from 'shared/ui/Aside/StyledAside';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import StoreMallDirectoryOutlinedIcon from '@mui/icons-material/StoreMallDirectoryOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import DownloadIcon from '@mui/icons-material/Download';

const settings = [
  { title: 'Отправка OTP', url: '/send-OTP' },
  { title: 'Страны', url: '/countries' },
  { title: 'Города', url: '/cities' },
  { title: 'Финансовые операторы', url: '/finance-operations' },
];

export const Aside = () => {
  const [expanded, setExpanded] = useState('');
  const navigate = useNavigate();

  return (
    <StyledAside>
      <StyledAsideLogo>
        <span />
      </StyledAsideLogo>
      <StyledAsideList component="nav">
        <ListItemButton onClick={() => setExpanded(expanded.startsWith('users') ? '' : 'users')}>
          <ListItemIcon>
            <GroupsOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Пользователи" />
          {expanded === 'users' || expanded === 'users-in' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          in={expanded === 'users' || expanded === 'users-in'}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
          >
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => setExpanded(expanded === 'users-in' ? 'users' : 'users-in')}
            >
              <ListItemText primary="Пользователи МП" />
              {expanded === 'users-in' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
            </ListItemButton>
            <Collapse
              in={expanded === 'users-in'}
              timeout="auto"
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
                sx={{
                  '.MuiButtonBase-root': {
                    paddingLeft: '100px',
                  },
                }}
              >
                <ListItemButton
                  sx={{ pl: 10 }}
                  onClick={() => navigate('/users-mp/b2b')}
                  selected={document.location.href.includes('users-mp/b2b')}
                >
                  <ListItemText primary="B2B" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 10 }}
                  onClick={() => navigate('/users-mp/b2c')}
                  selected={document.location.href.includes('users-mp/b2c')}
                >
                  <ListItemText primary="B2C" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 10 }}
                  onClick={() => navigate('/users-mp/b2cr')}
                  selected={document.location.href.includes('users-mp/b2cr')}
                >
                  <ListItemText primary="B2CR" />
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/shop-dots')}
              selected={document.location.href.includes('shop-dots')}
            >
              <ListItemText primary="Торговые точки" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/distributions')}
              selected={document.location.href.includes('distributions')}
            >
              <ListItemText primary="Уведомления" />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton onClick={() => setExpanded(expanded === 'promo' ? '' : 'promo')}>
          <ListItemIcon>
            <CampaignOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Промо и акции" />
          {expanded === 'promo' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          in={expanded === 'promo' || expanded === '/promo/competitions-b2b'}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
          >
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/promo/b2b')}
              selected={document.location.href.includes('/promo/b2b')}
            >
              <ListItemText primary="Промо B2B" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/promo/mechanic')}
              selected={document.location.href.includes('/promo/mechanic')}
            >
              <ListItemText primary="Механики" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/promo/prizes')}
              selected={document.location.href.includes('/promo/prizes')}
            >
              <ListItemText primary="Призы" />
            </ListItemButton>

            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() =>
                setExpanded(expanded.startsWith('/promo/competitions-b2b') ? 'promo' : '/promo/competitions-b2b')
              }
            >
              <ListItemText primary="Соревнования" />
              {expanded === '/promo/competitions-b2b' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
            </ListItemButton>

            <Collapse
              in={expanded === '/promo/competitions-b2b'}
              timeout="auto"
              unmountOnExit
            >
              <ListItemButton
                sx={{ pl: 13 }}
                onClick={() => navigate('/promo/competitions-b2b')}
                selected={document.location.href.includes('/promo/competitions-b2b')}
              >
                <ListItemText primary="Список соревнований B2B" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 13 }}
                onClick={() => navigate('/promo/competitions-b2cr')}
                selected={document.location.href.includes('/promo/competitions-b2cr')}
              >
                <ListItemText primary="Список соревнований B2CR" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 13 }}
                onClick={() => navigate('/promo/prize_places')}
                selected={document.location.href.includes('/promo/prize_places')}
              >
                <ListItemText primary="Призовые места" />
              </ListItemButton>
            </Collapse>
          </List>
        </Collapse>

        <ListItemButton onClick={() => setExpanded(expanded.startsWith('content') ? '' : 'content')}>
          <ListItemIcon>
            <ArticleOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Контент" />
          {expanded === 'content' || expanded === 'pages' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          in={expanded === 'content' || expanded === 'pages' || expanded === 'content-brands'}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
          >
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/content/banner')}
            >
              <ListItemText primary="Баннеры" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/content/bannertypes')}
            >
              <ListItemText primary="Типы баннеров" />
            </ListItemButton>
            <Collapse
              in={expanded === 'pages'}
              timeout="auto"
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
              >
                <ListItemButton
                  sx={{ pl: 13 }}
                  onClick={() => navigate('/content/pages/b2b')}
                  selected={document.location.href.includes('/content/pages/b2b')}
                >
                  <ListItemText primary="B2B" />
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => setExpanded(expanded === 'content-brands' ? 'content' : 'content-brands')}
            >
              <ListItemText primary="Бренды" />
              {expanded === 'content-brands' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
            </ListItemButton>
            <Collapse
              in={expanded === 'content-brands'}
              timeout="auto"
              unmountOnExit
            >
              <List
                component="div"
                disablePadding
              >
                <ListItemButton
                  sx={{ pl: 13 }}
                  onClick={() => navigate('/content/brands/b2b')}
                  selected={document.location.href.includes('/content/brands/b2b')}
                >
                  <ListItemText primary="B2B" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 13 }}
                  onClick={() => navigate('/content/brands/b2c')}
                  selected={document.location.href.includes('/content/brands/b2c')}
                >
                  <ListItemText primary="B2C" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 13 }}
                  onClick={() => navigate('/content/brands/b2cr')}
                  selected={document.location.href.includes('/content/brands/b2cr')}
                >
                  <ListItemText primary="B2CR" />
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton sx={{ pl: 10 }}>
              <ListItemText
                primary="Сторисы"
                onClick={() => navigate('/content/stories')}
              />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton onClick={() => setExpanded(expanded === 'marketplace' ? '' : 'marketplace')}>
          <ListItemIcon>
            <StoreMallDirectoryOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Маркетплейс" />
          {expanded === 'marketplace' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          in={expanded === 'marketplace'}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
          >
            <ListItemButton sx={{ pl: 10 }}>
              <ListItemText
                primary="Товары"
                onClick={() => navigate('/product')}
              />
            </ListItemButton>
            <ListItemButton sx={{ pl: 10 }}>
              <ListItemText
                primary="Категории"
                onClick={() => navigate('/category')}
              />
            </ListItemButton>
            <ListItemButton sx={{ pl: 10 }}>
              <ListItemText
                primary="Партнеры"
                onClick={() => navigate('/partner')}
              />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton onClick={() => setExpanded(expanded.startsWith('reports') ? '' : 'reports')}>
          <ListItemIcon>
            <ArticleOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Отчеты" />
          {expanded === 'reports' || expanded === 'pages' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          in={expanded === 'reports'}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
          >
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/bonuses_statistics')}
              selected={document.location.href.includes('bonuses_statistics')}
            >
              <ListItemText primary="Отчет по бонусам" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 10 }}
              onClick={() => navigate('/promo/reportPromo')}
              selected={document.location.href.includes('/promo/reportPromo')}
            >
              <ListItemText primary="Отчет по акциям" />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton onClick={() => setExpanded(expanded === 'settings' ? '' : 'settings')}>
          <ListItemIcon>
            <SettingsOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Настройки" />
          {expanded === 'settings' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          in={expanded === 'settings'}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
          >
            {settings.map((item) => (
              <ListItemButton
                key={item.url}
                sx={{ pl: 10 }}
                onClick={() => navigate(`/settings${item.url}`)}
              >
                <ListItemText primary={item.title} />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        <ListItemButton onClick={() => setExpanded(expanded === 'downloads' ? '' : 'downloads')}>
          <ListItemIcon>
            <DownloadIcon />
          </ListItemIcon>
          <ListItemText primary="Загрузки" />
          {expanded === 'downloads' ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
        </ListItemButton>
        <Collapse
          in={expanded === 'downloads'}
          timeout="auto"
          unmountOnExit
        >
          <ListItemButton
            sx={{ pl: 10 }}
            onClick={() => navigate('/downloads/shop-dots')}
            selected={document.location.href.includes('/downloads/shop-dots')}
          >
            <ListItemText primary="Акции - Торговые точки" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 10 }}
            onClick={() => navigate('/downloads/bonuses')}
            selected={document.location.href.includes('/downloads/bonuses')}
          >
            <ListItemText primary="Акции - Бонусы" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 10 }}
            onClick={() => navigate('/downloads/tables-code')}
            selected={document.location.href.includes('/downloads/tables-code')}
          >
            <ListItemText primary="Призы - Таблицы кодов" />
          </ListItemButton>
        </Collapse>
      </StyledAsideList>
    </StyledAside>
  );
};
